import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";
import { deleteDispatch, fetchDispatches } from "actions/Dispatches/dispatches";
import { abilitiesSelector } from "selectors/user";
import TablePageHolder from "components/TablePageHolder/TablePageHolder";
import { chemicalShape } from "constants/Chemicals/types";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar/Sidebar";
import { getDispatchesTableColumns } from "utils/dispatchesNew";
import { Button } from "semantic-ui-react";
import FlattenRecordsView from "components/FlattenRecordsView/FlattenRecordsView";

const StockNew = ({
  Can,
  location,
  route,
  isFetching,
  tableData,
  filterData,
  navigate
}) => {
  const [flatten, setFlatte] = useState(false);
  const [selectedItemsIds, setSelectedItems] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const dispatch = useDispatch();
  const getData = useCallback(
    params => {
      setSelectedItems([]);
      dispatch(fetchDispatches({ ...params }));
    },
    [fetchDispatches, filterData]
  );
  const onRowClick = useCallback(
    (event, row) => {
      if (!activeItem && row) {
        setActiveItem(row.original);
      }
    },
    [activeItem]
  );
  const onDelete = id => {
    dispatch(deleteDispatch(id));
  };
  const tableColumns = getDispatchesTableColumns(
    isFetching,
    navigate,
    onDelete
  );

  return (
    <>
      {
        <TablePageHolder
          mainButton={
            <Button as={Link} color="green" to={"/harvest/dispatches/dispatch"}>
              Add
            </Button>
          }
          getData={getData}
          navigate={navigate}
          isFetching={isFetching}
          location={location}
          withoutSearch={false}
          onRowClick={onRowClick}
          onSidebarHidden={() => setActiveItem(null)}
          sidebarShown={!!activeItem}
          pageTitle={route.name}
          route={route}
          withSelection={false}
          selectedItems={selectedItemsIds}
          setSelectedItems={setSelectedItems}
          flatten={flatten}
          flattenComponent={
            <FlattenRecordsView
              name="Stock"
              data={tableData.content}
              options={{}}
              getData={getData}
              isFetching={isFetching}
            />
          }
          setFlatte={setFlatte}
          withFlatten={true}
          sidebarComponent={
            <Sidebar
              id={activeItem && activeItem.id}
              dispatch={activeItem}
              setActiveItem={setActiveItem}
            />
          }
          tableColumns={tableColumns}
          tableData={tableData || []}
        />
      }
    </>
  );
};

StockNew.propTypes = {
  Can: PropTypes.func,
  isArchivedView: PropTypes.bool,
  tableData: PropTypes.shape({
    content: PropTypes.arrayOf(chemicalShape)
  }).isRequired,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalElements: PropTypes.number,
  fetchChemicals: PropTypes.func,
  isFetching: PropTypes.bool,
  route: PropTypes.object,
  filterValues: PropTypes.object,
  location: PropTypes.object
};

export default connect((state, props) => {
  const isArchivedView = props.location.pathname.includes("archived");

  return {
    isArchivedView,
    Can: abilitiesSelector(state),
    tableData: state.dispatches.data,
    isFetching: state.dispatches.isFetching
  };
})(StockNew);
